module.exports = __webpack_public_path__ + "static/img/renyi-b.6394451.png";


//////////////////
// WEBPACK FOOTER
// ./static/compress-img/public/customer/renyi-b.png
// module id = drEN
// module chunks = 1